import { uebersetze } from '../../i18n/sprache.js';

/* `uebersetze` statt `useTranslation`: ein Spinner steht auch an Stellen,
   die kein Sprachumfeld haben - etwa in einer Fehlergrenze. */
export function Spinner() {
  return <span className="spinner" role="status" aria-label={uebersetze('aria.laedt')} />;
}
